import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "Common/Loader";
import {
  deleteStoreOpsRole,
  getStoreOpsRolesById,
  updateStoreOpsRole,
} from "pages/Componets/API_Modal";
import notistack from "pages/Core/Notistack";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { StoreOpsModel } from "./Model/store-opration-model";
import { HttpStatus } from "pages/Core/http-status";
import useHasPermission from "hooks/useHasPermission";

interface selectedStoreProps {
  selectedIdStoreId: string;
  onDeleteSuccess: () => void;
  onUpdateSuccess: () => void;
  reloadDataSource: () => void;
}

export const StoreActionButtonsModal: React.FC<selectedStoreProps> = ({
  selectedIdStoreId,
  onDeleteSuccess,
  onUpdateSuccess,
  reloadDataSource,
}) => {
  const hasPermission = useHasPermission();
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [opnStoreDeleteModal, ShowStoreDeleteModal] = useState(false);
  const [opnStoreUpdateModal, ShowStoreUpdateModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [storeDetails, setStoreDetails] = useState<StoreOpsModel>();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
  } = useForm({
    defaultValues: {
      roleName: storeDetails?.roleName,
      Id: storeDetails?.id,
    },
    mode: "onChange",
  });

  const handleDeleteStore = (id: number) => {
    setSelectedId(id);
    ShowStoreDeleteModal(true);
  };

  const confirmDeleteCustomer = async () => {
    if (selectedId === null) return;
    try {
      setLoading(true);
      const response = await deleteStoreOpsRole(selectedId);
      notistack.notifyFromApi(response);
      ShowStoreDeleteModal(false);
      onDeleteSuccess();
    } catch (error) {
      console.error("Error deleting Customer data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStoreById = async (storeData: any) => {
    try {
      setLoading(true);
      const response = await getStoreOpsRolesById(storeData?.id);
      if (response.status === HttpStatus.Success) {
        setStoreDetails(response.data);
        ShowStoreUpdateModal(true);
        reset({
          roleName: response.data.roleName,
          Id: response.data.id,
        });
      } else {
        notistack.notifyFromApi(response);
      }
    } catch (error) {
      console.error("Failed to fetch Customer details:", error);
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const response: any = await updateStoreOpsRole(data);
      console.log(response);
      if (response.status === HttpStatus.Success) {
        toast.success(response.message);
        reset();
        ShowStoreUpdateModal(false);
        reloadDataSource();
      } else {
        toast.error(response.message);
      }
    } catch (error: any) {
      toast.error(error.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {hasPermission("StoreOpsRole.Delete") && (
        <button
          className="btn btn-sm action-btn delete-btn me-2"
          title="Delete"
          onClick={() => handleDeleteStore(Number(selectedIdStoreId))}
        >
          <FontAwesomeIcon icon={faTrash} className="ml-2" />
        </button>
      )}
      {hasPermission("StoreOpsRole.Write") && (
        <button
          className="btn btn-sm action-btn edit-btn"
          title="Edit"
          onClick={() => handleUpdateStoreById({ id: selectedIdStoreId })}
        >
          <FontAwesomeIcon icon={faPenToSquare} className="ml-2" />
        </button>
      )}

      {/* deleted modal */}
      <Modal
        show={opnStoreDeleteModal}
        onHide={() => ShowStoreDeleteModal(false)}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this customer?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => ShowStoreDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={confirmDeleteCustomer}
            disabled={loading}
          >
            {loading ? "Deleting..." : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* update store modal */}
      <Modal
        show={opnStoreUpdateModal}
        onHide={() => ShowStoreUpdateModal(false)}
        className="fade"
        dialogClassName="modal-dialog-centered"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Store Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-sm-12">
                <label>
                  Role Name: <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  id="roleName"
                  {...register("roleName", {
                    required: "Role Name is required",
                    pattern: {
                      value: /^(?!\s)([A-Za-z]+(\s{1,}[A-Za-z]+)*)$/,
                      message:
                        "Only letters and spaces are allowed. No leading or trailing spaces.",
                    },
                  })}
                />
                {errors.roleName && (
                  <span className="text-danger">
                    {String(errors.roleName.message)}
                  </span>
                )}
              </div>
            </div>
            <div className="d-flex justify-content-end  align-items-end mt-4">
              <button
                type="button"
                className="btn add-btn me-1"
                onClick={() => {
                  ShowStoreUpdateModal(false);
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Save"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};
